import React from 'react';
import { assetUrl } from '../../utils/assets';
import { Card } from '../../types';
import TierIndicator from './TierIndicator';
import './PlayableCard.css';

const CARD_TYPE_COLORS: { [key: string]: string } = {
  verb: '#7c5cbf',
  chaos: '#d35f5f',
  ally: '#6b8cce',
};

interface PlayableCardProps {
  card: Card;
  onClick?: (card: Card) => void;
  disabled?: boolean;
  className?: string;
  animatingIndex?: number;
}

const formatCardName = (name: string): string => {
  return name
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

const PlayableCard: React.FC<PlayableCardProps> = ({ card, onClick, disabled = false, className, animatingIndex }) => {
  const borderColor = CARD_TYPE_COLORS[card.type] || CARD_TYPE_COLORS.verb;

  const handleClick = () => {
    if (!disabled && onClick) {
      onClick(card);
    }
  };

  return (
    <div
      className={`playable-card ${card.tier || 'basic'} ${disabled ? 'disabled' : ''} ${className || ''}`}
      onClick={handleClick}
      style={{ borderColor }}
    >
      <div className="playable-card-title" style={{ backgroundColor: borderColor }}>
        {formatCardName(card.name)}
      </div>
      <div className="playable-card-artwork">
        <img
          src={assetUrl(`/assets/cards/${card.name}.png`)}
          alt={card.name}
          className="playable-card-image"
        />
      </div>
      {card.type === 'chaos' && (
        <div className="playable-card-chaos-badge">CHAOS</div>
      )}
      {card.type === 'verb' && card.tier && card.tier !== 'tier_3' && (
        <TierIndicator
          tier={card.tier}
          usageCount={card.usage_count ?? 0}
          animatingIndex={animatingIndex}
        />
      )}
    </div>
  );
};

export default PlayableCard;
